// Global Currency Configuration
export const CURRENCY_CONFIG = {
    code: 'GHS',
    symbol: 'GH₵',
    name: 'Ghanaian Cedi'
};


// Currency formatting utility function
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return `${CURRENCY_CONFIG.symbol} 0.00`;
  return `${CURRENCY_CONFIG.symbol} ${Number(amount).toFixed(2)}`;
};